'use client'

import { useAuth } from '@/contexts/AuthContext'
import { useRouter, useSearchParams } from 'next/navigation'
import { useEffect, Suspense, useRef } from 'react'

function HomeContent() {
  const { user, loading } = useAuth()
  const router = useRouter()
  const searchParams = useSearchParams()
  const hasRedirected = useRef(false)

  useEffect(() => {
    if (hasRedirected.current) return

    const type = searchParams.get('type')
    const code = searchParams.get('code')
    
    if (type === 'recovery' || code) {
      hasRedirected.current = true
      console.log('🔐 Home - Recovery detectado, redirecionando para callback')
      const params = new URLSearchParams(searchParams.toString())
      router.push(`/auth/callback?${params.toString()}`)
      return
    }

    if (!loading) {
      hasRedirected.current = true
      if (user) {
        router.push('/dashboard')
      } else {
        router.push('/login')
      }
    }
  }, [user, loading, router, searchParams])

  return null
}

export default function Home() {
  return (
    <Suspense fallback={null}>
      <HomeContent />
    </Suspense>
  )
}
